module.exports = __webpack_public_path__ + "static/media/new_logo.96a0ed6c.jpg";